import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1491 3.64977C15.8928 -0.912729 8.71723 -1.16273 4.1541 3.0929C1.9931 5.11359 0.70929 7.90016 0.577629 10.8558C0.445968 13.8114 1.47693 16.7011 3.4497 18.9059C5.42247 21.1108 8.18019 22.4554 11.1322 22.6519C14.0843 22.8485 16.9959 21.8812 19.2435 19.9573C19.3618 19.856 19.4783 19.7519 19.5928 19.6448C19.7078 19.5379 19.8197 19.4285 19.9291 19.3179C21.9801 17.2391 23.1482 14.448 23.1892 11.5281C23.2302 8.6081 22.1409 5.7853 20.1491 3.64977ZM21.0697 11.6935C20.987 14.0756 19.983 16.3327 18.2693 17.9893C16.5555 19.6459 14.2658 20.5728 11.8822 20.5748C11.7735 20.5748 11.6641 20.5729 11.5541 20.5691C10.346 20.5303 9.15761 20.2523 8.05767 19.7512C6.95773 19.2501 5.96807 18.5359 5.14598 17.6498C1.68535 13.9373 1.88848 8.10602 5.59848 4.6454C6.92915 3.404 8.59808 2.5851 10.3942 2.29227C12.1903 1.99944 14.0329 2.24583 15.689 3.00027C17.3451 3.75472 18.7402 4.98333 19.698 6.53073C20.6557 8.07813 21.1331 9.8748 21.0697 11.6935Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.93 28.4501L23.2344 20.4951L20.1719 23.3532L27.8688 31.3126C28.0559 31.5134 28.2809 31.6752 28.5308 31.7887C28.7807 31.9022 29.0507 31.9651 29.325 31.9739H29.3994C29.8074 31.9734 30.2063 31.8538 30.5473 31.6299C30.8884 31.4059 31.1566 31.0873 31.3191 30.713C31.4816 30.3388 31.5314 29.9253 31.4623 29.5232C31.3931 29.1211 31.2082 28.748 30.93 28.4495V28.4501Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6152 18.9811L18.9297 19.6206L21.6876 22.5771L22.3731 21.9376L19.6152 18.9811Z",
			fill: "currentColor"
		})
	] })
});
export default SvgSearch;
